export type MSpinnerSize = "xs" | "sm" | "md" | "lg" | "xl";

export interface MSpinnerProps {
  size?: MSpinnerSize | string | number;
  color?: string;
  thickness?: number;
}

export const mSpinnerDefaults = {
  size: "1em",
  thickness: 5,
} satisfies Partial<MSpinnerProps>;
